
<div class="modal-body" #form="ngForm" ngForm>
  <div class="form-group">
    <label translate for="createEditorProject-name">New project name</label>
    <input class="form-control" (keydown.enter)="form.form.valid ? create() : null" autofocus type="text" required nonEmpty maxlength="255" name="name" [(ngModel)]="name" data-test-qa="createEditorProjectName" id="createEditorProject-name">
  </div>
  <div class="form-line" *ngIf="subclipsClipboard.items.length">
    <div class="header">
      <div class="title" translate>Include subclips</div>
      <div class="description" [translate]="pluralize.selectedSubclips" [translateParams]="{count: subclipsClipboard.items.length}"></div>
    </div>
    <toggle [(ngModel)]="includeSubclips" name="includeSubclips" data-test-qa="includeSubclips"></toggle>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" [clickBlocking]="create" [disabled]="!form.form.valid" data-test-qa="create"><i class="far fa-check"></i><span translate>Create</span></button>
  <button class="btn btn-outline-secondary" (click)="cancel()" data-test-qa="cancel" translate>Cancel</button>
</div>